import script from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=4acffc40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4acffc40"]])

export default __exports__